import { memo, useCallback } from 'react';

import { cn } from '@air/utils-tailwind';

import { type WorkspaceTemplateConfig } from '~/components/Modals/BoardTemplateModal/types';

export type BoardTemplateModalTemplateSelectionProps = {
  selectedTemplateId: string | null;
  onSelectTemplate: (templateId: string) => void;
  templates: WorkspaceTemplateConfig[];
};

export const BoardTemplateModalTemplateSelection = memo(
  ({ selectedTemplateId, onSelectTemplate, templates }: BoardTemplateModalTemplateSelectionProps) => {
    const handleSelectTemplate = useCallback(
      (templateId: string) => () => {
        onSelectTemplate(templateId);
      },
      [onSelectTemplate],
    );

    return (
      <div className="flex w-1/2 flex-col gap-4">
        <p className="font-semibold text-14 text-grey-12">Available templates:</p>
        <div className="flex flex-col gap-2">
          {templates.map((template) => (
            <button
              key={template.id}
              type="button"
              onClick={handleSelectTemplate(template.id)}
              className={cn(
                'rounded-8 border p-4 text-left transition-colors',
                selectedTemplateId === template.id
                  ? 'border-blue-9 bg-blue-1'
                  : 'border-grey-5 bg-grey-1 hover:border-grey-7 hover:bg-grey-2',
              )}
            >
              <h3 className="font-semibold text-14 text-grey-12">{template.title}</h3>
              <p className="mt-1 text-12 text-grey-11">{template.description}</p>
            </button>
          ))}
        </div>
      </div>
    );
  },
);

BoardTemplateModalTemplateSelection.displayName = 'BoardTemplateModalTemplateSelection';
